// project import
import NavUser from './NavUser';
import Navigation from './Navigation';
import SimpleBar from '@/from-theme/components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
  <>
    <SimpleBar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Navigation />
    </SimpleBar>
    <NavUser />
  </>
);

export default DrawerContent;
